"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeHistory = void 0;
var react_1 = __importDefault(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
require("./styles/change-history.scss");
/**
 * Shared component for displaying change history across different features
 * Shows a collapsible list of historical changes with timestamps and summaries
 */
exports.ChangeHistory = function (_a) {
    var title = _a.title, changeHistory = _a.changeHistory, _b = _a.emptyMessage, emptyMessage = _b === void 0 ? 'No changes recorded' : _b, isExpanded = _a.isExpanded, onToggle = _a.onToggle, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, loadingComponent = _a.loadingComponent;
    // Filter out incomplete entries
    var filteredHistory = changeHistory.filter(function (entry) {
        if (!entry.timestamp) {
            return false;
        }
        return true;
    });
    var formatDateShort = function (timestamp) {
        var date = new Date(timestamp);
        return date.toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
    };
    var formatDateFull = function (timestamp) {
        var date = new Date(timestamp);
        return date.toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        });
    };
    var parseChangeSummary = function (changeSummary) {
        var emailRegex = /^([^\s]+@[^\s]+)\s+(.+)$/;
        var match = changeSummary.match(emailRegex);
        if (match) {
            return {
                email: match[1],
                action: match[2],
            };
        }
        return {
            email: '',
            action: changeSummary,
        };
    };
    var groupedHistory = [];
    filteredHistory.forEach(function (entry) {
        var _a = parseChangeSummary(entry.changeSummary), email = _a.email, action = _a.action;
        var timestamp = entry.timestamp;
        var existingGroup = groupedHistory.find(function (g) { return g.timestamp === timestamp && g.email === email; });
        if (existingGroup) {
            existingGroup.actions.push(action);
        }
        else {
            groupedHistory.push({
                timestamp: timestamp,
                email: email,
                actions: [action],
            });
        }
    });
    var capitalizeFirstLetter = function (str) {
        if (!str)
            return str;
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var renderActionWithBoldQuotes = function (action) {
        var capitalizedAction = capitalizeFirstLetter(action);
        var parts = [];
        var regex = /('[^']*')/g;
        var lastIndex = 0;
        var match;
        while ((match = regex.exec(capitalizedAction)) !== null) {
            if (match.index > lastIndex) {
                parts.push(capitalizedAction.substring(lastIndex, match.index));
            }
            parts.push(react_1.default.createElement("strong", { key: match.index }, match[1]));
            lastIndex = regex.lastIndex;
        }
        if (lastIndex < capitalizedAction.length) {
            parts.push(capitalizedAction.substring(lastIndex));
        }
        return react_1.default.createElement(react_1.default.Fragment, null, parts);
    };
    return (react_1.default.createElement("div", { className: "ws-change-history" },
        react_1.default.createElement("button", { className: "ws-change-history-toggle", onClick: onToggle, type: "button" },
            react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: isExpanded ? 'ChevronDown' : 'ChevronRight', className: "ws-change-history-chevron" }),
            title),
        isExpanded && (react_1.default.createElement("div", { className: "ws-change-history-content" }, isLoading ? (loadingComponent || react_1.default.createElement("div", { className: "ws-change-history-empty" }, "Loading...")) : filteredHistory.length === 0 ? (react_1.default.createElement(office_ui_fabric_react_1.MessageBar, { messageBarType: office_ui_fabric_react_1.MessageBarType.info }, emptyMessage)) : (react_1.default.createElement("div", { className: "ws-change-history-list-container" },
            react_1.default.createElement("ul", { className: "ws-change-history-list" }, groupedHistory.map(function (group, index) {
                return (react_1.default.createElement("li", { key: index, className: "ws-change-history-entry" },
                    react_1.default.createElement("span", { className: "ws-change-history-date", title: formatDateFull(group.timestamp) },
                        formatDateShort(group.timestamp),
                        react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: "Info", className: "ws-change-history-date-icon" })),
                    react_1.default.createElement("span", { className: "ws-change-history-separator" }, "-"),
                    group.email && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("span", { className: "ws-change-history-email" }, group.email),
                        react_1.default.createElement("span", { className: "ws-change-history-separator" }, "-"))),
                    react_1.default.createElement("span", { className: "ws-change-history-action" }, group.actions.map(function (action, actionIndex) { return (react_1.default.createElement("span", { key: actionIndex, className: "ws-change-history-action-item" },
                        renderActionWithBoldQuotes(action),
                        actionIndex < group.actions.length - 1 && ', ')); }))));
            }))))))));
};
